import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Loader } from '@beholos/holoscommon';
import { API_BASE_URL } from '../../services/constants';
import { trackEvent } from '../../services/analytics.service';

export default function LoginMagic() {
  const [params] = useSearchParams();

  useEffect(() => {
    const run = async () => {
      const token = params.get('token');
      const next = params.get('next');
      if (!token) {
        window.location.href = '/iniciar-sesion';
        return;
      }

      try {
        const resp = await fetch(`${API_BASE_URL}/auth/verify-magic`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token }),
          credentials: 'include',
        });

        if (!resp.ok) {
          window.location.href = '/iniciar-sesion';
          return;
        }

        const data = await resp.json();
        if (data?.accessToken) {
          sessionStorage.setItem('token', data.accessToken);
          const expiresIn = data.expiresIn < 10000000000
            ? Date.now() + (data.expiresIn * 1000)
            : data.expiresIn;
          sessionStorage.setItem('expiresIn', String(expiresIn));

          trackEvent('login_magic_success');
          window.location.href = next || data.redirectUrl || '/user/';
          return;
        }

        window.location.href = '/iniciar-sesion';
      } catch {
        window.location.href = '/iniciar-sesion';
      }
    };

    run();
  }, [params]);

  return (
    <div className="h-screen w-full flex items-center justify-center">
      <div className="flex flex-col items-center gap-3">
        <Loader />
        <p className="text-sm text-slate-600">Verificando acceso…</p>
      </div>
    </div>
  );
}


